import React from 'react';
import PropTypes from 'prop-types';
import {Message} from '../../';


const AccessError = ({supportName, supportUrl}) => {
    return (
        <div>
            <Message
                as="p"
                code="errors.com.epicgames.ecommerce.payout.esports.participation_form.access_denied"
                args={[supportUrl, supportName]}
            />
        </div>
    );
};

AccessError.displayName = 'AccessError';

AccessError.propTypes = {
    supportName: PropTypes.string,
    supportUrl: PropTypes.string
};

export default AccessError;
